export default function SummaryCard({ title, value, subtitle, icon: Icon, color = "blue", trend }) {
  const colorMap = {
    blue: {
      bg:     "bg-primary-50   dark:bg-primary-900/30",
      icon:   "text-primary-600 dark:text-primary-400",
      border: "border-primary-100 dark:border-primary-800/50",
    },
    green: {
      bg:     "bg-secondary-50  dark:bg-secondary-900/30",
      icon:   "text-secondary-600 dark:text-secondary-400",
      border: "border-secondary-100 dark:border-secondary-800/50",
    },
    red: {
      bg:     "bg-red-50   dark:bg-red-900/30",
      icon:   "text-red-600 dark:text-red-400",
      border: "border-red-100 dark:border-red-800/50",
    },
    yellow: {
      bg:     "bg-yellow-50   dark:bg-yellow-900/30",
      icon:   "text-yellow-600 dark:text-yellow-400",
      border: "border-yellow-100 dark:border-yellow-800/50",
    },
    purple: {
      bg:     "bg-purple-50   dark:bg-purple-900/30",
      icon:   "text-purple-600 dark:text-purple-400",
      border: "border-purple-100 dark:border-purple-800/50",
    },
  };
  const c = colorMap[color] || colorMap.blue;

  return (
    <div className={`card border ${c.border}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">{title}</p>
          <p className="mt-1 text-2xl font-bold text-gray-900 dark:text-gray-100">{value}</p>
          {subtitle && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
          {trend && (
            <p className={`mt-1 text-xs font-medium ${trend.up ? "text-secondary-600 dark:text-secondary-400" : "text-red-600 dark:text-red-400"}`}>
              {trend.up ? "▲" : "▼"} {trend.label}
            </p>
          )}
        </div>
        {Icon && (
          <div className={`p-2.5 rounded-lg ${c.bg}`}>
            <Icon className={`w-5 h-5 ${c.icon}`} />
          </div>
        )}
      </div>
    </div>
  );
}
